export default "__VITE_ASSET__6Ut2$OAD__"